import React, { useState } from "react";
import { products } from "../data";
import { Link } from "react-router-dom";
import { message } from "antd";

function AllProducts() {
  const [sort, setSort] = useState("lowToHigh");
  const [category, setCategory] = useState("all");
  const [search, setSearch] = useState("");

  const addProductToCart = (product) => {
    // dispatch(addToCart(product));
    if (sessionStorage.getItem("cartItems") == null) {
      product.qty = 1;
      sessionStorage.setItem("cartItems", JSON.stringify([product]));
    } else {
      const cartItems = JSON.parse(sessionStorage.getItem("cartItems"));
      const check = cartItems.filter((item) => item.productId === product.productId);
      if (check.length == 0) {
        product.qty = 1;
        sessionStorage.setItem("cartItems", JSON.stringify([...cartItems, product]));
      }
    }
    message.success("Product Successfully added to Cart", [1]);
  };

  const addToWishList = (product) => {
    if (sessionStorage.getItem("wishlistItems") == null) {
      sessionStorage.setItem("wishlistItems", JSON.stringify([product]));
    } else {
      const wishlistItems = JSON.parse(sessionStorage.getItem("wishlistItems"));
      const check = wishlistItems.filter((item) => item.productId == product.productId);
      if (check.length == 0) {
        sessionStorage.setItem("wishlistItems", JSON.stringify([...wishlistItems, product]));
      }
    }
    message.success("Product Successfully added to Wishlist", [1]);
  };
  return (
    <div className="d-flex flex-column align-items-center">
      <div className="container mb-2">
        <h4 className="ml-3 mt-5 mb-2" style={{ textTransform: "uppercase ", fontWeight: "600" }}>
          All Products
        </h4>
        <div className="row">
          <div className="col-lg-3 col-md-4 col-sm-6 col-12 mt-3 d-flex align-items-baseline justify-content-center">
            <h6 className="mr-2" style={{ fontWeight: "600" }}>
              Price
            </h6>
            <select onChange={(e) => setSort(e.target.value)} style={{ border: "none", outline: "none", borderRadius: "5px" }} className="px-3 py-1">
              <option value="lowToHigh">Low to high</option>
              <option value="highToLow">High to low</option>
            </select>
          </div>
          <div className="col-lg-3 col-md-4 col-sm-6 mt-3  col-12  d-flex align-items-baseline justify-content-center">
            <h6 className="mr-2" style={{ fontWeight: "600" }}>
              Category
            </h6>
            <select
              onChange={(e) => setCategory(e.target.value)}
              style={{ border: "none", outline: "none", borderRadius: "5px" }}
              className="px-3 py-1"
            >
              <option value="all">All</option>
              <option value="Laptop">Laptops</option>
              <option value="Phone">Phones</option>
              <option value="Headphones">Headphones</option>
            </select>
          </div>
          <div className="col-lg-6 col-md-4 col-sm-12 mt-3 col-12 px-0  d-flex ">
            <button class="btn btn-outline-success my-2 my-sm-0" type="submit" style={{ border: "none" }}>
              <i className="fa fa-search"></i>
            </button>
            <input
              className="form-control mr-2 "
              type="search"
              id="searchproduct"
              placeholder="Search"
              aria-label="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
        <div className="row mt-5">
          {products
            .filter((product) => product.productName.toLowerCase().includes(search.toLowerCase()))
            .sort((a, b) => (sort === "lowToHigh" ? a.price - b.price : b.price - a.price))
            .map((product, i) => {
              if (product.category === category || category === "all")
                return (
                  <div className="col-lg-3 col-md-6 col-sm-6 mb-5" key={product.productId}>
                    <div className="product-wrapper text-center">
                      <div className="product-img">
                        <img src={product.url} className="productimage" alt="" />
                        <span className="text-center">
                          <i class="fas fa-dollar-sign" />
                          {product.price}
                        </span>
                        <div className="product-action">
                          <div className="product-action-style">
                            <Link className="wishlist" onClick={() => addToWishList(product)}>
                              <i className="fa fa-heart wishlist" />
                            </Link>
                            <Link className="cart" onClick={() => addProductToCart(product)}>
                              <i className="fa fa-shopping-cart " />
                            </Link>
                          </div>
                        </div>
                      </div>
                      <Link to={`/productdescription/${product.productId}`}>
                        <h6 className="mt-2" style={{ fontWeight: "600" }}>
                          {product.productName}
                        </h6>
                      </Link>
                    </div>
                  </div>
                );
            })}
        </div>
      </div>
    </div>
  );
}
export default AllProducts;
